module.exports = __webpack_public_path__ + "img/logo.c239f551.png";